import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"
import App from './App';
import brand from './brand';

// Set before the first render so the CSS variables in _global.css resolve
// to the right brand colors immediately — no flash of the wrong theme.
document.documentElement.dataset.brand = brand.id;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);